const MonetizationPlusProMaxABLightValues = Object.freeze({
    plus: {
        base: 'linear-gradient(246.37deg, #F9AE4A 13.41%, #C209C1 82.6%)',
        text: '#fff',
    },
    pro: {
        base: 'linear-gradient(60.72deg, #0E00AC -11%, #FF34F9 86.67%)',
        text: '#fff',
    },
    max: {
        base: 'linear-gradient(250.06deg, #00CFFD 20.89%, #0019FC 93.39%)',
        text: '#fff',
    },
});
const MonetizationPlusProMaxABDarkValues = Object.freeze({
    plus: {
        base: 'linear-gradient(246.37deg, #F9AE4A 13.41%, #C209C1 82.6%)',
        text: '#fff',
    },
    pro: {
        base: 'linear-gradient(60.72deg, #0E00AC -11%, #FF34F9 86.67%)',
        text: '#fff',
    },
    max: {
        base: 'linear-gradient(250.06deg, #00CFFD 20.89%, #0019FC 93.39%)',
        text: '#fff',
    },
});

export { MonetizationPlusProMaxABDarkValues, MonetizationPlusProMaxABLightValues };
